module.exports = __webpack_public_path__ + "img/zs4.bbae5b6c.png";